import { AbstractTracker } from './abstract';
export class PostHogTracker extends AbstractTracker {
  constructor(instance) {
    super();
    this.register(instance);
  }

  register(instance) {
    this.posthog = instance;
  }

  setGroup(groupType, groupKey, groupProperties) {
    this.posthog.group(groupType, groupKey, { ...groupProperties });
  }

  setTenant(id, properties) {
    this.setGroup('tenant', id, { ...properties });
  }

  setUserId(id, properties, properties_to_set_once) {
    this.posthog.identify(id, { ...properties }, { ...properties_to_set_once });
  }

  setVersion(version) {
    this.posthog.register('app_version', version);
  }

  track(eventName, properties) {
    this.posthog.capture(eventName, properties);
  }

  trackPage(properties) {
    this.track('$pageview', properties);
  }

  reset() {
    this.posthog.reset();
    this.posthog.resetGroups();
  }

  isFeatureEnabled(flag_key) {
    return this.posthog.isFeatureEnabled(flag_key);
  }
}
